export default __webpack_public_path__ + "static/media/caroselImg.8f574bd7.jpg";